import { Button, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { MonitoringOperatorCustomerRoleValue } from "../../../statics";

// 検索フォーム
export interface ItemForm {
    mainid:any;
    ip_address:any;
}

export type EditDeviceIdAllocationFormProps = {
    initialData: any,
    onOK: (data: any) => void;
    onCancel: () => void;
};

export const EditDeviceIdAllocation = (props: EditDeviceIdAllocationFormProps) => {
    const { onOK, onCancel, initialData } = props;

    // 初期値設定
    const initialValue: ItemForm = {
        mainid: initialData.mainid,
        ip_address: initialData.ip_address,
    }

    const { handleSubmit, formState: { errors }, control, setValue, clearErrors, getValues } = useForm<ItemForm>({
        mode: 'all',
        criteriaMode: "all",
        defaultValues: initialValue,
    });

    // Submitイベント
    const handleEditSubmit = (value: ItemForm) => {
        const request = createRequestData(value);
        onOK(request);
    }

    // FormデータからRequestデータを作成する
    const createRequestData = (formValue: ItemForm) => {
        const params = {
            ip_address:formValue.ip_address,
            mainid:formValue.mainid,
        }
        return params;
    }

    // キャンセル
    const handleCancel = () => {
        onCancel();
    };

    return (
        <>
            <div style={{ height: '100%', width: '100%',marginTop:"15px" }}>
                <Stack direction='row' justifyContent="flex-start" spacing={1.5} alignItems='center'>
                    <Typography variant="h5">装置ID引当情報編集</Typography>
                </Stack>
                <form onSubmit={handleSubmit(handleEditSubmit)}>
                    <Stack spacing={3} mt={2}>
                        <Stack spacing={4} direction={{ xs: 'column', sm: 'row' }} mt={3} style={{ marginLeft: '10px' }}>
                            <Grid container spacing={1} direction="row">
                                <Controller
                                    name="ip_address"
                                    rules={{
                                        required: '必須項目です。入力してください。',
                                        pattern: {
                                            value: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
                                            message: 'IPアドレスタイプを入力してください。'
                                        },
                                    }}
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            fullWidth
                                            type="text"
                                            label="IPアドレス"
                                            size="small"
                                            inputProps={{ maxLength: 15 }}
                                            error={!!errors?.ip_address}
                                            helperText={errors?.ip_address?.message}
                                            InputProps={{
                                                readOnly:true
                                            }}
                                            style={{backgroundColor:"floralwhite"}}
                                        />
                                    )}
                                />
                            </Grid>
                        </Stack>
                        <Stack spacing={4} direction={{ xs: 'column', sm: 'row' }} mt={3} style={{ marginLeft: '10px' }}>
                            <Grid container spacing={1} direction="row">
                                <Controller
                                    name="mainid"
                                    control={control}
                                    rules={{
                                        required: '必須項目です。入力してください。',
                                        pattern: {
                                            value: /^[a-zA-Z0-9]+$/,
                                            message: '半角英数字のみ可能'
                                        },
                                        maxLength: {
                                            value: 6,
                                            message: '最大6文字まで'
                                        },
                                    }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            fullWidth
                                            type="text"
                                            label="装置ID"
                                            size="small"
                                            error={!!errors?.mainid}
                                            helperText={errors?.mainid?.message}
                                        />
                                    )}
                                />
                            </Grid>
                        </Stack>
                    </Stack>
                    <Stack direction='row' justifyContent="flex-end" spacing={2} sx={{ width:"98%" ,mt: 2,marginLeft:"10px"}}>
                        <Button variant="contained" type="submit">保存</Button>
                        <Button color="inherit" variant="contained" onClick={handleCancel}>キャンセル</Button>
                    </Stack>
                </form>
            </div>
        </>
    );
};

export default EditDeviceIdAllocation;